// Packages
import tw, { styled, css } from "twin.macro";

// Images
import LogoAsset from "../../_images/amex.svg";
import BackgroundFlourish from "../../_images/main-background-flourish.svg";

// Modal mask
export const ModalMask = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`absolute w-full h-full z-40`,
]);

export const Logo = styled.div(() => [
  `width:150px; height:41px; left: 20px; top: 32px; background-image: url("${LogoAsset}");`,
  tw`absolute z-10`,
]);

export const Main = styled.main(({ isJP }) => [
  `background-color:#404143;`,
  `@media screen and (min-width: 768px)`,
  tw`relative min-h-screen overflow-x-hidden bg-[#F7F8F9]`,
]);

export const Flourish = styled.div(() => [
  `aspect-ratio: 1 / 5; background-image: url("${BackgroundFlourish}"); max-height: calc(100% - 660px);`,
  `
  @media screen and (min-width: 768px) {
    max-height: calc(100% - 460px)
  }
  `,
  `
  @media screen and (min-width: 1024px) {
    max-height: calc(100% - 560px)
  }
  `,
  tw`absolute w-1/3 top-[660px] md:top-[460px] lg:top-[560px] bg-no-repeat bg-contain`,
]);

export const Container = styled.div(() => [
  ``,
  tw`max-w-5xl mx-auto px-4 relative z-10`,
]);

const introContent = css`
  p + p {
    margin-top: 1em;
  }
`;

export const Checkbox = styled.div(() => [
  ``,
  tw`text-copy text-white text-right relative `,
  introContent,
]);
